import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import {
  CREATE_REPORTING_CYCLE,
  GET_COMMENTS,
  GET_REPORTING_CYCLE,
} from '../constants/user-api-constants';
import { ReportingCycleDetails } from '../models/reportingcycle.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportingCycleService {
  constructor(private apiService: ApiService) {}

  public getDetails() {
    return this.apiService.fetchData(`${GET_REPORTING_CYCLE}`);
  }

  getDetail(id: number) {
    return this.apiService.fetchData(`${GET_REPORTING_CYCLE}/${id}`);
  }

  public postReportingCycleData(
    currentReportingCycleData: ReportingCycleDetails,
  ): Observable<any> {
    return this.apiService.postData(
      CREATE_REPORTING_CYCLE,
      currentReportingCycleData,
    );
  }

  public postReportingCycleCommentData(
    id: number,
    currentReportingCycleData: ReportingCycleDetails,
  ): Observable<any> {
    return this.apiService.postData(
      `${CREATE_REPORTING_CYCLE}/${id}`,
      currentReportingCycleData,
    );
  }

  public getCommentsData(loginID: number): Observable<any> {
    return this.apiService.fetchData(`${GET_COMMENTS}${loginID}`);
  }
}
